import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Details from '../components/details/details';
import BuyCommunBalance from '../components/buy-commun-balance/buy-commun-balance';
import Invoices from '../components/invoices/invoices';
import Header from '../../../components/header/header';

import { searchDetails, searchCommunicationBalance } from '../actions/details';
import { getComunicationCostOptions } from '../../../actions/select-options';

class CustomerArea extends Component {
  componentDidMount() {
    const {
      userLogged: { user },
      searchCommunicationBalance,
      getComunicationCostOptions,
      searchDetails,
    } = this.props;

    searchCommunicationBalance();
    getComunicationCostOptions();

    searchDetails({
      id: user.clientId
    });
  }

  render() {
    const {
      userLogged,
    } = this.props;

    return (
      <>
        <Header userLogged={userLogged} />
        <Details />

        <BuyCommunBalance />
        <Invoices />
      </>
    )
  }
}

const mapStateToProps = ({ authReducer: { authenticated } }) => ({
  userLogged: authenticated,
});

const mapDispatchToProps = dispath => {
  return bindActionCreators({
    searchCommunicationBalance,
    getComunicationCostOptions,
    searchDetails,
  }, dispath)
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerArea);
